export const backendURL = process.env.REACT_APP_BACKEND_URL;
export const metadataQueryURL = process.env.REACT_APP_METADATA_QUERY_URL;
export const feedbackURL = process.env.REACT_APP_FEEDBACK_URL;